import { component } from 'picoapp'

export default component((node, ctx) => {
    
    let flickityOptions = {
        wrapAround: true,
        pageDots: true,
        fade: true
    };

    const aboutFlickity = new Flickity( node, flickityOptions );

    // call resize after the page loads to fix bug with pjax
    setTimeout(function() {
        aboutFlickity.resize();
    }, 500);

})
